export default {
	SAVE_PATIENT_BUS: "data_bus/SAVE_PATIENT_BUS",
}